import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   *  Shows the loading indicator.
   *
   *  @return {void} No return value.
   */
  showLoading(): void {
    this.isLoadingSubject.next(true);
  }

  /**
   *  Hides the loading indicator.
   *
   *  @return {void} No return value.
   */
  hideLoading(): void {
    this.isLoadingSubject.next(false);
  }

  /**
   * Retrieves an observable indicating whether the loading indicator is currently visible.
   *
   * @return {boolean} An observable that emits a boolean value indicating whether the loading indicator is visible.
   */
  public get loadingState(): Observable<boolean> {
    return this.isLoadingSubject.asObservable();
  }
}
